module.exports = __webpack_public_path__ + "img/blog_icon_active.279636de.svg";